import { BASE_URL } from '../configs/config';

export const runRestaurantClosedProcedure = async (rest_id: string) => {
  try {
    const res = await fetch(`${BASE_URL}runRestaurantClosedProcedure?rest_id=${rest_id}`, {
      method: 'GET',
      cache: 'no-cache',
    });
    const data = await res.json();
    return data;
  } catch (error) {}
};
